import classNames from 'classnames';
import React, { FC, useState } from 'react';
import { IllustrationType } from '../../../enums/IllustrationType';
import { ProjectPlan } from '../../../enums/ProjectPlan';
import Button from '../../../utils/button/Button';
import { ButtonLinkExternal } from '../../../utils/button/ButtonLink';
import Card from '../../../utils/card/Card';
import Col from '../../../utils/column/Col';
import Illustration from '../../../utils/illustration/Illustration';
import Row from '../../../utils/row/Row';
import Toggle from '../../../utils/toggle/Toggle';
const monthlyFee = 1.3;
const price = {
    [ProjectPlan.STARTER]: {
        monhtly: 1500,
        annualy: 15000
    },
    [ProjectPlan.ESSENTIALS]: {
        monhtly: 3500,
        annualy: 35000
    },
    [ProjectPlan.PRO]: {
        monhtly: 5000,
        annualy: 50000
    }
}

interface PlanSelectorProps {
    plan: ProjectPlan;
    setPlan: (newPlan: ProjectPlan) => void;
    setPeriod: (newPeriod: boolean) => void;
    period: boolean; // true === yearly
    className?: string;
}

const PlanSelector : FC<PlanSelectorProps> = ({
    plan,
    setPlan,
    setPeriod,
    period,
    className,
}) => {

// function PlanSelector({plan, setPlan, setPeriod, period, className}) {

    const [planCustom, setPlanCustom] = useState<boolean>(false);

    return (
        <div className={"project-plan "+(className!==undefined?className:"")}>
            <h3 className="text-center">
                Vyber si tarif 🏷
            </h3>
            <p className="text-center">
                Stejně jako v zoo čipmánky, i našeho Eatera musíš něčím krmit. Čím víc ho naláduješ, tím více z něj dostaneš zpět. Nelam si s tím ale moc hlavu. Kdykoliv by ti krmení došlo nebo jsi zjistil, že toho máš hodně, můžeš během procesu založení projektu upravit.
            </p>
            {/* <div className="paydate text-center"> */}
            <div className='period-toggle'>
                <div>
                    <Toggle
                        leftValue='Měsíčně'
                        rightValue='Ročně '
                        checked={period}
                        setChecked={setPeriod}
                        dimUnchecked={true}
                    />
                    <span className='toggle-explain'>
                        (ušetříte 20 %)
                    </span>
                </div>
            </div>
            {/* </div> */}
            <div className="plan-list">
                <Row>
                    <Col width={4}>
                        <Card 
                            padding='narrow'
                            border={(plan===ProjectPlan.PRO||plan===ProjectPlan.CUSTOM) && "primary" || "white"}
                            className={'card-plan '+(plan===ProjectPlan.PRO||plan===ProjectPlan.CUSTOM?" card-selected border-thick":"")}
                        >
                            <div className="custom-plan">
                                <Button
                                    design='link'
                                    onClick={()=>setPlanCustom(false)}
                                    className={classNames(!planCustom && "active")}
                                >
                                    <h6>Velký</h6>
                                </Button>
                                <span className="col-2">|</span>
                                <Button
                                    design='link'
                                    onClick={()=>setPlanCustom(true)}
                                    className={classNames(planCustom && "active")}
                                >
                                    <h6>Na míru</h6>
                                </Button>
                            </div>
                            <p className="text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, pellentesque phasellus ut sed.</p>
                            <span className='price-calc'>
                                <h5>
                                    {planCustom?
                                    "Individuálně":
                                    (period?price[ProjectPlan.PRO].annualy:price[ProjectPlan.PRO].monhtly).toLocaleString()
                                    }
                                </h5>
                                <p className="text-center">{period ? "Ročně" : "Měsíčně"}</p>
                            </span>
                            <p className="text-center color-primary">=</p>
                            {planCustom?
                            <p className="text-center">
                                ? klíčových slov<br/>
                                ? konkurentů
                            </p>:
                            <p className="text-center">
                                3 500 klíčových slov<br/>
                                20 konkurentů
                            </p>}
                            <Button
                                className='select-plan'
                                onClick={()=>setPlan(ProjectPlan.PRO)}
                                design={plan === ProjectPlan.PRO? 'primary' : 'secondary'}
                            >
                                {(plan===ProjectPlan.PRO?"Vybráno":"Vybrat")}
                            </Button>
                        </Card>
                    </Col>
                    <Col
                        width={4}
                    >
                        <Card 
                            padding='narrow' 
                            className={'card-plan position-relative plan-popular '+(plan===ProjectPlan.ESSENTIALS?" card-selected border-thick":"")}
                            border={plan === ProjectPlan.ESSENTIALS && "primary" || "white"}
                        >
                            <span className="pill">
                                Oblíbený
                            </span>
                            <h6>Střední</h6>
                            <p className="text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, pellentesque phasellus ut sed.</p>
                            <span className='price-calc'>
                                <h5>{(period?price[ProjectPlan.ESSENTIALS].annualy:price[ProjectPlan.ESSENTIALS].monhtly).toLocaleString()}</h5>
                                <p className="text-center">{period ? "Ročně" : "Měsíčně"}</p>
                            </span>
                            <p className="text-center color-primary">=</p>
                            <p className="text-center">
                                3 500 klíčových slov<br/>
                                20 konkurentů
                            </p>
                            <Button
                                className='select-plan'
                                onClick={()=>setPlan(ProjectPlan.ESSENTIALS)}
                                design={plan === ProjectPlan.ESSENTIALS? 'primary' : 'secondary'}
                            >
                                {(plan===ProjectPlan.ESSENTIALS?"Vybráno":"Vybrat")}
                            </Button>
                        </Card>
                        </Col>
                    <Col width={4}>
                        <Card 
                            padding='narrow' 
                            className={'card-plan '+(plan===ProjectPlan.STARTER?" card-selected border-thick":"")}
                            border={plan === ProjectPlan.STARTER && "primary" || "white"}
                        >
                            <h6>Malý</h6>
                            <p className="text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, pellentesque phasellus ut sed.</p>
                            <span className='price-calc'>
                                <h5>{(period?price[ProjectPlan.STARTER].annualy:price[ProjectPlan.STARTER].monhtly).toLocaleString()}</h5>
                                <p className="text-center">{period ? "Ročně" : "Měsíčně"}</p>
                            </span>
                            <p className="text-center color-primary">=</p>
                            <p className="text-center">
                                3 500 klíčových slov<br/>
                                20 konkurentů
                            </p>
                            <Button
                                className='select-plan'
                                onClick={()=>setPlan(ProjectPlan.STARTER)}
                                design={plan === ProjectPlan.STARTER? 'primary' : 'secondary'}
                            >
                                {(plan===ProjectPlan.STARTER?"Vybráno":"Vybrat")}
                            </Button>
                        </Card>
                    </Col>
                    <Illustration img={IllustrationType.ProjectPlan} className="plan-selector-illustration" />
                </Row>
                <p className="text-center additional">
                    Potřebuješ více informací? 
                    <ButtonLinkExternal
                        to='https://www.keywordeater.cz/'
                        design='link'
                    >
                        Mrkni sem
                    </ButtonLinkExternal>
                </p>
            </div>
        </div>
    );
}

export default PlanSelector;